<!-- 运维视图：人员进出 -->
<template>
    <el-row :span="24">
        <el-col :span="12">
            <span v-if="loadingRealtimeData">
                <i class="el-icon-loading">
                </i>
            </span>
            <span v-else>
                <span v-if="realtimeData.length <= 0" style="color: #66b1ff;">
                    • 人员进出现场实时人数{{realtimeData.length}}人
                </span>
                <el-link v-else @click="toRegisterCheck(realtimeData)" type="primary">• 人员进出现场实时人数{{realtimeData.length}}人</el-link>
            </span>
        </el-col>
        <el-col :span="12">
            <span v-if="loadingUnauthorizedData">
                <i class="el-icon-loading">
                </i>
            </span>
            <span v-else>
                <span v-if="unauthorizedData.length <= 0" style="color: #66b1ff;">
                    • 人员进出未授权{{unauthorizedData.length}}人
                </span>
                <el-link v-else @click="toRegisterCheck(unauthorizedData)" type="primary">• 人员进出未授权{{unauthorizedData.length}}人</el-link>
            </span>
        </el-col>
    </el-row>
</template>

<script>
    import RegisterServer from '@/api/register';
    import {RESOURCE_IP_PORT} from "@/api";
    import {addParamsToUrl} from "@/util";

    async function getRealtimeData(departmentId) {
        let data = [];
        if (departmentId != null) {
            data = await RegisterServer.registerRecord.realTimeRegisterrecord(departmentId);
        }
        return Promise.resolve(data);
    }
    async function getUnauthorizedData(departmentId, startDateTime, endDateTime) {
        let data = [];
        if (departmentId != null && startDateTime != null && endDateTime != null) {
            data = await RegisterServer.registerRecord.abnormalRecords(departmentId, startDateTime, endDateTime);
        }
        return Promise.resolve(data);
    }

    export default {
        name: "operation-board-register",
        props: {
            departmentId: {},
            startDateTime: {},
            endDateTime: {},
        },
        data() {
            return {
                loadingRealtimeData: false,
                loadingUnauthorizedData: false,
                realtimeData: [],
                unauthorizedData: [],
            };
        },
        computed: {
            loadUnauthorizedDataTrigger() {
                return {
                    departmentId: this.departmentId,
                    startDateTime: this.startDateTime,
                    endDateTime: this.endDateTime,
                };
            },
        },
        watch: {
            'departmentId': {
                immediate: true,
                async handler() {
                    this.loadingRealtimeData = true;
                    this.loadRealtimeData().finally(() => {
                        this.loadingRealtimeData = false;
                    })
                },
            },
            'loadUnauthorizedDataTrigger': {
                immediate: true,
                deep: true,
                async handler() {
                    this.loadingUnauthorizedData = true;
                    this.loadUnauthorizedData().finally(() => {
                        this.loadingUnauthorizedData = false;
                    })
                },
            },
        },
        methods: {
            async loadRealtimeData() {
                this.realtimeData = await getRealtimeData(this.departmentId);
                return Promise.resolve(this.realtimeData);
            },

            async loadUnauthorizedData() {
                this.unauthorizedData = await getUnauthorizedData(this.departmentId, this.startDateTime, this.endDateTime);
                return Promise.resolve(this.unauthorizedData);
            },
            toRegisterCheck(ids) {
                if (ids == null || ids.length <= 0) {
                    return;
                }
                window.open(addParamsToUrl(`${process.env.VUE_APP_WEB_API}/athub/register/check.html?m=510701&registerrecordids=${ids.join(',')}`, {
                }))
            },
        },
    }
</script>

<style scoped>
    * {
        line-height: 14px;
    }
    a.el-link.is-underline {
        text-decoration: none;
    }
</style>

